import { DataModel } from "common/models/utility-models/base-model";

export class InternshipModel extends DataModel {

    selectedBatch: any[] = [];
    selectedRegion: any[] = [];
    selectedBranch: any[] = [];
    selectedState: any[] = [];
    searchText: string = "";
    inviteStatus: any[] = [];
    fromDate: string = '';
    toDate: string = '';
    studentsList: any[] = [
        {
            name: '',
            invite: '',
            reInvite: '',
            available: '',
            assigned: '',
            startDate: '',
            endDate: '',
            company: '.',
            companyLocation: '',
            certificate: '',
            email: '',
            mobile: '',
            branch: '',
            college: '',
            region: '',
            id: '',
            internshipMasterIds: '',
            batch: '',
        }
    ];
    internshipList: any[] = [
        {
            internshipTitle: '',
            companyName: '',
            location: '',
            startDate: '',
            endDate: '',
            mentorName: '',
            studentCount: 0,
            id: '',
            internshipMasterIds: ''
        }
    ];

    //------------Internship Stats Data-----------------
    internshipStats = {
        totalInternships: 1 ,
        assignedStudents: 1 ,
        joinedStudents: 1,
        notJoined: 0,
        completed: 0,
        discontinued: 0
    };

    //------------Student Chart Data-----------------
    invitationCounts = {
        invited: 50,
        notInvited: 30,
        total: 80
    };

    availabilityCounts =
        {
            available: 40,
            notAvailable: 20,
            notResponded: 30,
            total: 90
        };

    assignedCounts = {
        assigned: 25,
        notAssigned: 35,
        total: 60
    };

    completionCounts = {
        completed: 20,
        discontinued: 20,
        notJoined: 40,
        total: 50
    };

    //------------Internship Chart Data-----------------
    internassignedCounts = {
        joined: 50,
        notJoined: 30,
        total: 80
    };

    joinedCounts = {
        continued: 40,
        disContinued: 20,
        total: 60
    };

    interncontinueCounts = {
        completed: 25,
        disContinued: 25,
        notJoined: 35,
        total: 85
    };

    interncompletionCounts = {
        completed: 20,
        notCompleted: 40,
        total: 60
    };

    

    apiResData: any[]
    pageData: { totalInternships: any; };
}